// Shared admin auth helper
import { useNavigate } from "react-router-dom";

const TOKEN_KEY = "ipg_admin_token";
const EMAIL_KEY = "ipg_admin_email";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getEmail = () => localStorage.getItem(EMAIL_KEY);

export const setSession = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EMAIL_KEY, email);
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const useRequireAuth = () => {
  const navigate = useNavigate();
  return () => {
    if (!getToken()) navigate("/admin/login", { replace: true });
  };
};
